import React from "react";
import ropayLogoSVG from '../assets/svg/newLogo.svg'
import ropayLogoWhiteSVG from '../assets/svg/newLogoWhite.svg'

const Logo = ({ width, height, white }) => {
  return (
    <div className='logo_container'>
      <img
        src={white ? ropayLogoWhiteSVG : ropayLogoSVG}
        alt='CentelHR logo'
        style={{
          width: width ? width : '',
          height: height ? height : '',
        }}
      />
    </div>
  )
};

export default Logo;